/*
 * Copyright © 2022 EPO: European Patent Office.
 * ALL RIGHTS RESERVED
 */

import { Avatar, makeStyles, Typography } from '@material-ui/core';
import React from 'react';
import clsx from 'clsx';

const useStyles = makeStyles(theme => ({
  welcomeBlock: {
    display: 'flex',
    flexFlow: 'column wrap',
  },
  welcomeText: {
    color: theme.palette.welcomeText,
  },
  welcomeTextContrast: {
    color: theme.palette.welcomeTextContrast,
  },
  userInfo: {
    display: 'flex',
  },
  userInitialsText: {
    fontSize: '1.25rem',
    fontWeight: '700',
    marginTop: theme.spacing(0.25),
  },
  avatarPrimary: {
    color: theme.palette.avatar.primary.text,
    backgroundColor: theme.palette.avatar.primary.background,
    marginRight: '0.5rem',
  },
  description: {
    fontWeight: 400,
    marginBottom: '1.5rem',
    [theme.breakpoints.up('lg')]: {
      flexBasis: '75%',
    },
  },
  content: {
    display: 'flex',
    flexFlow: 'row wrap',
    justifyContent: 'space-between',
    alignItems: 'center',
    marginTop: '1rem',
  },
  welcomeTitle: ({ configurableHeaderEnabled }) => ({
    marginTop: configurableHeaderEnabled ? '0.5rem' : '1.5rem',
    [theme.breakpoints.up('lg')]: {
      marginTop: configurableHeaderEnabled ? '0.5rem' : '3.5rem',
    },
  }),
  welcomeExtraTitle: {
    fontWeight: 400,
  },
  welcomeSubtitle: {
    marginTop: 0,
    marginBottom: '1.125rem',
  },
}));

export default function WelcomeSection(props) {
  const {
    title,
    extraTitle,
    description,
    initials,
    contrast,
    showUserProfile,
    subtitle,
    name,
    configurableHeaderEnabled,
  } = props;
  const classes = useStyles({ configurableHeaderEnabled });

  return (
    <section className={clsx(classes.welcomeBlock, `${contrast ? classes.welcomeTextContrast : classes.welcomeText}`)}>
      <Typography className={classes.welcomeTitle} variant="h1" id="myWelcomeLabel">
        {title}
      </Typography>

      {extraTitle && (
        <Typography className={classes.welcomeExtraTitle} variant="h3" id="myWelcomeExtraLabel">
          {extraTitle}
        </Typography>
      )}

      {subtitle && (
        <Typography className={classes.welcomeSubtitle} variant="h2">
          {subtitle}
        </Typography>
      )}
      {showUserProfile && (
        <>
          <Typography variant="h3">Admin</Typography>
          <div className={classes.userInfo}>
            <Avatar className={classes.avatarPrimary}>
              <Typography className={classes.userInitialsText}>{initials}</Typography>
            </Avatar>
            <Typography variant="h4">{name}</Typography>
          </div>
        </>
      )}
      <div className={classes.content}>
        <Typography
          paragraph
          component="p"
          variant="h4"
          gutterBottom
          className={classes.description}
          id="myWelcomeDescription"
        >
          {/* Enables the addition of stylized html in welcome section description requested by OEPM */}
          <div dangerouslySetInnerHTML={{ __html: description }} />
        </Typography>
      </div>
    </section>
  );
}
